import axios from 'axios'
import {keycloak} from '@/main'


const domain = window.location.hostname.replace(/^www\./, '').split('.')[0];


const api = axios.create({
    //baseURL: 'https://metrocairo-api.magentalab.it', // Production API URL
    baseURL: 'https://' + domain + "-api", // Production API URL
    // baseURL: 'http://localhost:8090', // Use this for local testing with a local instance of the API
})

// Interceptor to add JWT token 
api.interceptors.request.use(async config => {
        const refreshed = await keycloak.updateToken(60)
        const token = keycloak?.token
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        if (refreshed === undefined) {
            keycloak.login()
        }
        return config
    },
    error => Promise.reject(error)
)

export default api
